"use client"

import { createContext, useContext, useState, useEffect, useCallback } from "react"
import { apiRequest } from '../utils/apiRequest'
import { formatMoney as _formatMoney, formatPriceRange as _formatPriceRange, CURRENCY_SYMBOLS } from '../utils/currency'

const CurrencyContext = createContext(undefined)

export const CurrencyProvider = ({ children }) => {
  const [defaultCurrency, setDefaultCurrency] = useState('ZAR')

  useEffect(() => {
    loadDefaultCurrency()
  }, [])

  const loadDefaultCurrency = async () => {
    try {
      const response = await apiRequest({ method: "GET", url: "settings/currency" })
      if (response.data?.currency) {
        setDefaultCurrency(response.data.currency)
      }
    } catch {
      // Use default ZAR
    }
  }

  const formatMoney = useCallback((amount, currency) => {
    return _formatMoney(amount, currency || defaultCurrency)
  }, [defaultCurrency])

  const formatRange = useCallback((range, currency) => {
    return _formatPriceRange(range, currency || defaultCurrency)
  }, [defaultCurrency])

  const currencySymbol = CURRENCY_SYMBOLS[defaultCurrency] || defaultCurrency

  return (
    <CurrencyContext.Provider value={{
      defaultCurrency,
      currencySymbol,
      formatMoney,
      formatRange,
      refreshCurrency: loadDefaultCurrency,
    }}>
      {children}
    </CurrencyContext.Provider>
  )
}

export const useCurrency = () => {
  const context = useContext(CurrencyContext)
  if (context === undefined) {
    throw new Error("useCurrency must be used within a CurrencyProvider")
  }
  return context
}
